"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateSectionPrompts = generateSectionPrompts;
exports.generateGoogleAdPrompt = generateGoogleAdPrompt;
exports.generateFacebookAdPrompt = generateFacebookAdPrompt;

function generateSectionPrompts(sections) {
  var requiredSections = {
    premise: 'Premise underpinning communications',
    messagePromise: 'Message Promise',
    valueProposition: 'Value Proposition',
    brandVoice: 'Brand Voice',
    keyTriggers: 'Key Triggers'
  };
  var keys = Object.keys(requiredSections);
  var values = Object.values(requiredSections);
  var prompts = {
    premise: '',
    messagePromise: '',
    valueProposition: '',
    brandVoice: '',
    keyTriggers: ''
  };

  for (var ix = 0; ix < values.length; ix++) {
    var indexLabel = values[ix];

    for (var ixx = 0; ixx < sections.length; ixx++) {
      if (sections[ixx] && sections[ixx].label === indexLabel) {
        var sectionMessages = sections[ixx].messages;
        var joined = sectionMessages.join('. ');
        var indexKey = keys[ix];
        prompts[indexKey] = joined;
      }
    }
  }

  return prompts;
}

function generateGoogleAdPrompt(submittedData, sections) {
  var prompts = getGooglePrompts();
  var myprompt = '';
  myprompt += prompts.intro;
  myprompt += prompts.company;
  myprompt += prompts.services;
  myprompt += prompts.keywords;
  myprompt += " " + submittedData.secondary + ". ";
  myprompt += prompts.cta;
  myprompt += prompts.usp + ": " + submittedData.proposition + ". "; //Brief Stream Customisation

  if (sections.premise) myprompt += prompts.premise + ": " + sections.premise + ". ";
  if (sections.messagePromise) myprompt += prompts.messagePromise + ": " + sections.messagePromise + ". ";
  if (sections.valueProposition) myprompt += prompts.valueProposition + ": " + sections.valueProposition + ". ";
  if (sections.brandVoice) myprompt += prompts.brandVoice + ": " + sections.brandVoice + ". ";
  if (sections.keyTriggers) myprompt += prompts.keyTriggers + ": " + sections.keyTriggers + ". "; // Actions

  myprompt += prompts.headlines + ". ";
  myprompt += prompts.actionOne;
  myprompt += prompts.actionTwo;
  myprompt += prompts.promptConfig; // string replace input fields

  myprompt = myprompt.replaceAll('<COMPANY_NAME>', submittedData.company);
  myprompt = myprompt.replaceAll('<BUSINESS_TYPE>', submittedData.businessType);
  myprompt = myprompt.replaceAll('<PRIMARY>', submittedData.primary);
  myprompt = myprompt.replaceAll('<SERVICE>', submittedData.services);
  return myprompt;
}

function generateFacebookAdPrompt(submittedData, sections) {
  var prompts = getFacebookPrompts();
  var myprompt = '';
  myprompt += prompts.intro;
  myprompt += prompts.company;
  myprompt += prompts.services;
  myprompt += prompts.headlines + ". ";
  myprompt += prompts.cta;
  myprompt += prompts.usp + ": " + submittedData.proposition + ". "; //Brief Stream Customisation

  if (sections.premise) myprompt += prompts.premise + ": " + sections.premise;
  if (sections.messagePromise) myprompt += prompts.messagePromise + ": " + sections.messagePromise;
  if (sections.valueProposition) myprompt += prompts.valueProposition + ": " + sections.valueProposition;
  if (sections.brandVoice) myprompt += prompts.brandVoice + ": " + sections.brandVoice;
  if (sections.keyTriggers) myprompt += prompts.keyTriggers + ": " + sections.keyTriggers; // Actions

  myprompt += prompts.actionOne;
  myprompt += prompts.actionTwo;
  myprompt += prompts.actionThree;
  myprompt += prompts.promptConfig; // string replace input fields

  myprompt = myprompt.replaceAll('<COMPANY_NAME>', submittedData.company);
  myprompt = myprompt.replaceAll('<BUSINESS_TYPE>', submittedData.businessType);
  myprompt = myprompt.replaceAll('<PRIMARY>', submittedData.primary);
  myprompt = myprompt.replaceAll('<SERVICE>', submittedData.services);
  return myprompt;
}

function getGooglePrompts() {
  // Submitted Values
  var intro = 'Imagine you are a marketing expert, specialising in Google Ads. ';
  var company = 'You are creating ad copy for a client called <COMPANY_NAME>. ';
  var services = 'They are one of the leading <BUSINESS_TYPE> in Melbourne. This ad will focus particularly on their service <SERVICE>. We are looking to generate Google Ad headlines and descriptions for an ad group targeting keywords based on the service. ';
  var keywords = 'The primary keyword of this ad group is <PRIMARY>, but the ad group is also targeting the following secondary keywords:';
  var cta = 'The call to action for the ads will be: Get In Touch. ';
  var usp = 'Some additional selling points/callouts to consider include';
  var premise = 'the premise underpinning the ad copy should be';
  var messagePromise = 'The message promise should vary between';
  var valueProposition = 'The Value Proposition should vary between';
  var brandVoice = 'The brand voice should have';
  var keyTriggers = 'The key triggers in the copy should include';
  var headlines = 'We are looking to generate Google Ad headlines for an ad group targeting roughly based on this list of primary and secondary keywords, as well as the unique callouts for this company.'; // Headings

  var actionOne = 'Create 10 ad headlines we could use for a Google Responsive Search Ad. These headlines need to be between 50 and 70 characters in length, including spaces, with each word starting with a capital letter. The headline options need to include the primary and secondary keywords, and the call to action, and some options need to have a reference to the location.'; // Descriptions

  var actionTwo = 'After that, create 10 ad descriptions for the Google Responsive Search Ad. These descriptions must be between 100 and 150 characters in length, including spaces, with sentence case capitalisation. Half of the descriptions should be written to sell the expertise of <COMPANY_NAME> for the service that aligns with the intent of someone searching the keywords. They should include the primary keyword and selling points/callouts of <COMPANY_NAME>. But only include the clients name in half of the descriptions.'; // Prompt Rules

  var promptConfig = 'These headlines and descriptions should be written in Australian English and use a tone of voice that is professional and authoritative. Return these results as a JSON object, each one as an array of strings assigned to the response property "headlines" and "descriptions" respectively.';
  return {
    intro: intro,
    company: company,
    services: services,
    headlines: headlines,
    premise: premise,
    messagePromise: messagePromise,
    valueProposition: valueProposition,
    brandVoice: brandVoice,
    keyTriggers: keyTriggers,
    cta: cta,
    usp: usp,
    keywords: keywords,
    actionOne: actionOne,
    actionTwo: actionTwo,
    promptConfig: promptConfig
  };
}

function getFacebookPrompts() {
  // Submitted Values
  var intro = 'Imagine you are a marketing expert, specialising in Facebook Ads. ';
  var company = 'You are creating ad copy to drive brand awareness for a client called <COMPANY_NAME>. ';
  var services = 'They sell <SERVICES>.';
  var headlines = 'We are looking to generate Facebook Ad Copy, headlines and descriptions for this company. ';
  var cta = 'The call to action for the ads will be: Get In Touch. ';
  var usp = 'Some additional selling points/callouts to consider include';
  var premise = 'the premise underpinning the ad copy should be';
  var messagePromise = 'The message promise should vary between';
  var valueProposition = 'The Value Proposition should vary between';
  var brandVoice = 'The brand voice should have';
  var keyTriggers = 'The key triggers in the copy should include'; // Headings

  var actionOne = 'Create 10 ad headlines we could use. ' + 'These headlines need to be between 50 and 70 characters long, including spaces, with each word starting with a capital letter. ' + 'The headline options should focus on the selling points as well as statements that would appear to the audience.' + 'Some options need to have a reference to the location. ' + 'Do not put emojis in the headline results.' + 'These headings need to be returned as an array of strings in the response property called "headings"';
  var actionTwo = 'Create 10 ad descriptions we could use. ' + 'These descriptions need to be between 75 and 90 characters in length, including spaces, with each word starting with a capital letter. ' + 'The description options should have similarities with the headlines in terms of a focus on the selling points, but we want them to build on the ad headlines. ' + 'Some options need to have a reference to the location. Do not put emojis in the description results. ' + 'These descriptions need to be returned as an array of strings in the response property called "descriptions".'; // Ad Copy

  var actionThree = 'Create 6 variations of ad copy we could use to drive awareness for <COMPANY_NAME>. ' + 'These should be formatted in 2 small paragraphs, each with 2-3 sentences. ' + 'The first sentence of the first paragraph should start with an attention-grabbing question or statement that the audience would relate to or resonate with. ' + 'The rest of the first paragraph should include content that the audience will further resonate with. ' + 'This content should include both two things: 1, the additional selling points/callouts listed and 2, general content that fits the brief of "audience will further resonate with". ' + 'The second paragraph should end with the ad call to action, and the lead-in to that call to action should be further selling points/callouts that add depth to the first paragraph. ' + 'Include an appropriate emoji or two in the ad copy results - these may look best at the end of the first and/or second paragraph. ' + 'These ad copy variations must be in sentence case capitalisation and stored as an array of strings in the response property called "adCopy". '; // Prompt Rules

  var promptConfig = 'These ad copy variations, headlines and descriptions should be written in Australian English and use a tone of voice that is friendly and authoritive and approachable.' + 'Return these results as a JSON object, each one as an array of strings assigned to the response property "headlines", "descriptions" and "adCopy" respectively.';
  return {
    intro: intro,
    company: company,
    services: services,
    headlines: headlines,
    premise: premise,
    messagePromise: messagePromise,
    valueProposition: valueProposition,
    brandVoice: brandVoice,
    keyTriggers: keyTriggers,
    cta: cta,
    usp: usp,
    actionOne: actionOne,
    actionTwo: actionTwo,
    actionThree: actionThree,
    promptConfig: promptConfig
  };
}